module.exports = __webpack_public_path__ + "img/python.af46fae9.png";